import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizBrowserExport } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'
import Criteria from '../../components/criteria'
import AcceptanceResults from '../../components/acceptanceResults'
import Result from '../../components/result'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/preAuditProcess/result/look') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('preAuditResultLook', record)
        } else {
            record = Session.get('preAuditResultLook') || {}
        }
    }
    return record
}

class PreAuditResultLook extends WizContainer {

    componentName = 'PreAuditResultLook'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _exportFilename = (filename) => {
        let { shortName, orgName, preSalesNumber, afterSalesNumber, moduleType } = this.state.record
        return `${filename}-${shortName || orgName}(${preSalesNumber && afterSalesNumber ? preSalesNumber + ',' + afterSalesNumber : preSalesNumber || afterSalesNumber})-${moduleType === 0 ? '销售' : '售后'}.xlsx`
    }

    _onExportResults = (data) => {
        let columns = [{
            headerName: '',
            width: 30,
            field: 'rowIndex',
            hidden: true,
            suppressMovable: true,
            cellStyle: {
                textAlign: 'center',
                padding: '5px 0',
                color: '#595959',
                backgroundColor: '#f0f0f0',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '500',
                boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
            }
        }, {
            headerName: '评估模块',
            field: 'mode',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }, {
            headerName: '模块达标率',
            field: 'modeComplianceRate',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }, {
            headerName: '要素情况',
            children: [{
                headerName: '要素',
                field: 'essentialFactor',
                width: 20,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'left', horizontal: 'center' } }
            }, {
                headerName: '达标数',
                field: 'standardsNumber',
                width: 20,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'left', horizontal: 'center' } }
            }, {
                headerName: '未达标数',
                field: 'substandardNumber',
                width: 20,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'left', horizontal: 'center' } }
            }]
        }, {
            headerName: '达标率',
            field: 'complianceRate',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }, {
            headerName: '评估结果',
            field: 'results',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }]

        let sheets = data.map((item, index) => {
            let { sheetName, rows } = item
            let rowMergeCell = []
            rows = rows.map((row, index) => {
                let { span } = row
                if (span > 1) {
                    rowMergeCell.push(`A${index + 4}:A${index + 3 + span}`)
                    rowMergeCell.push(`B${index + 4}:B${index + 3 + span}`)
                }
                return row
            })
            if (rows.length > 1) {
                rowMergeCell.push(`G${index + 4}:G${index + 3 + rows.length}`)
            }
            return {
                title: sheetName,
                titleParams: {
                    font: {
                        size: 14, color: { argb: '3A3A3A' }
                    }
                },
                sheetName,
                columns: columns.filter((_, index) => index),
                rows,
                rowMergeCell,
                filename: this._exportFilename('预审核验收结果')
            }
        })

        WizBrowserExport(sheets)
    }

    _onExportCriteria = (data) => {
        let columns = [{
            headerName: '',
            width: 30,
            field: 'rowIndex',
            hidden: true,
            suppressMovable: true,
            cellStyle: {
                textAlign: 'center',
                padding: '5px 0',
                color: '#595959',
                backgroundColor: '#f0f0f0',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '500',
                boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
            }
        }, {
            headerName: '要素',
            field: 'essentialFactor',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }, {
            headerName: '一级指标',
            field: 'primaryIndex',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }, {
            headerName: '评估标准',
            field: 'evaluationCriteria',
            width: 40,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'left', horizontal: 'center' } }
        }, {
            headerName: '评估结果',
            field: 'results',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }, {
            headerName: '备注',
            field: 'remarks',
            width: 20,
            cellStyle: { textAlign: 'left' },
            style: { alignment: { vertical: 'middle', horizontal: 'center' } }
        }]

        let sheets = data.map((item, index) => {
            let { sheetName, rows } = item
            let rowMergeCell = []
            rows = rows.map((row, index) => {
                let { evaluationCriteria, rowSpans } = row
                row.evaluationCriteria = evaluationCriteria.replaceAll('<br/>', '\n')
                if (row.results === -1) {
                    row.results = ''
                } 
                if (rowSpans.essentialFactorSpan > 1) {
                    rowMergeCell.push(`A${index + 3}:A${index + 2 + rowSpans.essentialFactorSpan}`)
                }
                if (rowSpans.primaryIndexSpan > 1) {
                    rowMergeCell.push(`B${index + 3}:B${index + 2 + rowSpans.primaryIndexSpan}`)
                }
                return row
            })
            return {
                title: sheetName,
                titleParams: {
                    font: {
                        size: 14, color: { argb: '3A3A3A' }
                    }
                },
                sheetName,
                columns: columns.filter((_, index) => index),
                rows,
                rowMergeCell,
                filename: this._exportFilename('预审核标准')
            }
        })

        WizBrowserExport(sheets)
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { processContentId, recordId } = this.state.record
        this.doActions([{
            path: 'counselingProcess/acceptanceResults',
            payload: {
                key: 'preAuditAcceptanceResults@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1
                }
            }
        }, {
            path: 'counselingProcess/evaluationCriteria',
            payload: {
                key: 'preAuditEvaluationCriteriaLook@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1
                }
            }
        }, {
            path: 'counselingProcess/preAuditOrCheckDetail',
            payload: {
                key: 'preAuditResultDetail@' + recordId,
                apiParams: {
                    id: recordId
                }
            }
        }])
    }

    render() {
        let { record } = this.state
        let { auditAcceptanceResults, evaluationCriteria, result, counselingProcessLoading } = this.props
        let content = ''
        if (result && result.data && result.data.content) {
            content = result.data.content
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <AcceptanceResults data={auditAcceptanceResults.data} title='预审核验收结果' type='look' onExport={this._onExportResults} />
                <Criteria data={evaluationCriteria.data} title='预审核标准' type='look' onExport={this._onExportCriteria} />
                <Result title='预审核结果' type='look' content={content} />
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId, recordId } = findParamRecord(ownProps.history)
    const evaluationCriteria = modelUtils.getModelEntity(counselingProcess, 'preAuditEvaluationCriteriaLook@' + processContentId)
    const auditAcceptanceResults = modelUtils.getModelEntity(counselingProcess, 'preAuditAcceptanceResults@' + processContentId)
    const result = modelUtils.getModelEntity(counselingProcess, 'preAuditResultDetail@' + recordId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        evaluationCriteria,
        auditAcceptanceResults,
        result,
        ...loading
    }
}

export default connect(mapStateToProps)(PreAuditResultLook)


